<h1 class="table__title">Audit Trail</h1>
<ul class="table__control inline-list">
  <li>
    <mat-form-field>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Search" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </li>
</ul>
<ng-template #noDocs>
  <h4>No Audit entries</h4>
</ng-template>
<div class="table__container">
  <table *ngIf="audits?.length > 0;else noDocs" class="table__inner" mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="Creator">
      <th mat-header-cell *matHeaderCellDef>By</th>
      <td mat-cell *matCellDef="let row;let element;">{{ element?.propertiesObj?.Creator }}
      </td>
    </ng-container>
    <ng-container matColumnDef="DateCreated">
      <th mat-header-cell *matHeaderCellDef>When</th>
      <td mat-cell *matCellDef="let row;let element;">{{ element?.propertiesObj?.DateCreated | aspenDate}}
      </td>
    </ng-container>
    <ng-container matColumnDef="ClassDescription">
      <th mat-header-cell *matHeaderCellDef>Type</th>
      <td mat-cell *matCellDef="let row;let element;">{{ element?.propertiesObj?.ClassDescriptionDisplay }}
      </td>
    </ng-container>

    <ng-container matColumnDef="EventStatus">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let row;let element;">
        {{ element?.propertiesObj?.EventStatus === 0 ? 'Success' : 'Failure' }}</td>
    </ng-container>

    <ng-container matColumnDef="Changes">
      <th mat-header-cell *matHeaderCellDef>Details</th>
      <td mat-cell *matCellDef="let row;let element;">
        <ng-container *ngIf="element?.propertiesObj?.ClassDescription === 'ViewEvent'">
          <ul>
            <li>{{element?.propertiesObj?.Changes}}</li>
          </ul>
        </ng-container>
        <ng-container *ngIf="element?.propertiesObj?.ClassDescription === 'LinkEvent'">
          <ul>
            <li>{{element?.propertiesObj?.Changes}}</li>
          </ul>
        </ng-container>
        <ng-container *ngIf="element?.propertiesObj?.ClassDescription === 'ChangeClassEvent'">
          <ul>
            <li>{{element?.propertiesObj?.Changes | asyncChoiceList:objectStore:'ACLDocumentClasses' | async}}</li>
          </ul>
        </ng-container>
        <ng-container *ngIf="element?.propertiesObj?.ClassDescription === 'UpdateEvent'">
          <ul>
            <li *ngFor="let change of element?.propertiesObj?.Changes">
              <ng-container [ngSwitch]="change?.type">
                <ng-container *ngSwitchCase="'class java.util.Date'">{{change?.fieldName }} :
                  {{change?.oldValue| aspenDate}} to
                  {{change?.newValue| aspenDate}}</ng-container>
                <ng-container *ngSwitchCase="'class java.lang.Boolean'">{{change?.fieldName }} :
                  {{change?.oldValue}} to
                  {{change?.newValue}}</ng-container>
                <ng-container *ngSwitchCase="'class [Ljava.lang.String;'">{{change?.fieldName }} :
                  {{change?.oldValue}} to
                  {{change?.newValue}}</ng-container>
                <ng-container *ngSwitchCase="'class java.lang.String'">{{change?.fieldName }} :
                  {{change?.oldValue}} to
                  {{change?.newValue}}</ng-container>
                <ng-container *ngSwitchCase="'class [Ljava.lang.Integer;'">
                  <ng-container [ngSwitch]="change?.fieldName">
                    <ng-container *ngSwitchCase="'ContractProducts'">{{change?.fieldName }} : [<span
                        *ngFor="let o of change?.oldValue">
                        {{o | asyncChoiceList:objectStore:'allProducts':'allProducts' | async}}, </span>] to [<span
                        *ngFor="let n of change?.newValue">
                        {{n | asyncChoiceList:objectStore:'allProducts':'allProducts' | async}}, </span>]
                    </ng-container>
                    <ng-container *ngSwitchCase="'ContractTerritories'">{{change?.fieldName }} : [<span
                        *ngFor="let o of change?.oldValue">
                        {{o | asyncChoiceList:objectStore:'allTerritories':'allTerritories' | async}}, </span>] to
                      [<span *ngFor="let n of change?.newValue">
                        {{n | asyncChoiceList:objectStore:'allTerritories':'allTerritories' | async}}, </span>]
                    </ng-container>
                    <ng-container *ngSwitchCase="'ContractMolecules'">{{change?.fieldName }} : [<span
                        *ngFor="let o of change?.oldValue">
                        {{o | asyncChoiceList:objectStore:'allMolecules':'allMolecules' | async}}, </span>] to [<span
                        *ngFor="let n of change?.newValue">
                        {{n | asyncChoiceList:objectStore:'allMolecules':'allMolecules' | async}}, </span>]
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      {{change?.fieldName}} : {{change?.oldValue}} to
                      {{change?.newValue}}
                    </ng-container>
                  </ng-container>

                </ng-container>
                <ng-container *ngSwitchCase="'class java.lang.Integer'">
                  <ng-container [ngSwitch]="change?.fieldName">
                    <ng-container *ngSwitchCase="'ContractDeleteReason'">{{change?.fieldName }} :
                      {{change?.oldValue | asyncChoiceList:objectStore:'ContractDeletedReason' | async}} to
                      {{change?.newValue | asyncChoiceList:objectStore:'ContractDeletedReason' | async}}</ng-container>
                    <ng-container *ngSwitchCase="'ContractAgreementType'">{{change?.fieldName }} :
                      {{change?.oldValue | asyncChoiceList:objectStore:'ContractAgreementTypes' | async}} to
                      {{change?.newValue | asyncChoiceList:objectStore:'ContractAgreementTypes' | async}}</ng-container>
                    <ng-container *ngSwitchCase="'ContractStatus'">{{change?.fieldName }} :
                      {{change?.oldValue | asyncChoiceList:objectStore:'ContractStatuses' | async}} to
                      {{change?.newValue | asyncChoiceList:objectStore:'ContractStatuses' | async}}</ng-container>
                    <ng-container *ngSwitchCase="'ContractType'">{{change?.fieldName }} :
                      {{change?.oldValue | asyncChoiceList:objectStore:'ContractTypes' | async}} to
                      {{change?.newValue | asyncChoiceList:objectStore:'ContractTypes' | async}}</ng-container>
                    <ng-container *ngSwitchCase="'ContractBusinessOwner'">{{change?.fieldName }} :
                      {{(change?.oldValue | asyncBusinessOwnerEntity | async)?.fullname}} to
                      {{(change?.newValue | asyncBusinessOwnerEntity | async)?.fullname}}
                    </ng-container>

                    <ng-container *ngSwitchDefault>{{change?.fieldName }} :
                      {{change?.oldValue}} to
                      {{change?.newValue}}</ng-container>
                  </ng-container>
                </ng-container>
                <ng-container *ngSwitchDefault>{{change?.type}} {{change?.fieldName}} : {{change?.oldValue}} to
                  {{change?.newValue}}</ng-container>
              </ng-container>

            </li>
          </ul>
        </ng-container>
      </td>
    </ng-container>



    <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true">
    </tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{indirectRow:!row.direct}"></tr>
  </table>
</div>
<div class="table__pagination">
  <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
</div>
